export interface Customer {
  user_id: number;
  company_name: string;
  contact_person: string;
  phone: string;
  alternate_phone?: string;
  status: CustomerStatus;
  created_at: string;
  updated_at: string;
  
  // Joined fields from users table
  name: string;
  email: string;
  
  // Calculated fields
  total_shipments: number;
  total_spent: number;
  last_shipment?: string;
}

export interface CustomerAddress {
  id: number;
  customer_id: number;
  address_line: string;
  city: string;
  region: string;
  postal_code: string;
  country: string;
  is_default: boolean;
  created_at: string;
  updated_at: string;
}

export interface CustomerStats {
  total_customers: number;
  active_customers: number;
  inactive_customers: number;
  total_revenue: number;
  average_order_value: number;
  top_customers: Customer[];
}

export interface CreateCustomerDto {
  user_id: number;
  company_name: string;
  contact_person: string;
  phone: string;
  alternate_phone?: string;
  status: CustomerStatus;
}

export interface UpdateCustomerDto {
  company_name: string;
  contact_person: string;
  phone: string;
  alternate_phone?: string;
  status: CustomerStatus;
}

export interface CreateAddressDto {
  address_line1: string;
  address_line2?: string;
  city: string;
  state: string;
  postal_code: string;
  country: string;
  is_default?: boolean;
}

export interface CustomerWithAddresses extends Customer {
  addresses: CustomerAddress[];
}

export interface CustomerShipmentHistory extends Customer {
  shipments: any[]; // Using any[] to avoid circular dependency with Shipment
  stats: {
    total_shipments: number;
    total_spent: number;
    last_shipment?: string;
  };
}

export type CustomerStatus = 'active' | 'inactive' | 'suspended';
export type AddressType = 'billing' | 'shipping' | 'both';

export const CUSTOMER_STATUS_OPTIONS: { value: CustomerStatus; label: string }[] = [
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
  { value: 'suspended', label: 'Suspended' }
];

export const ADDRESS_TYPE_OPTIONS: { value: AddressType; label: string }[] = [
  { value: 'billing', label: 'Billing' },
  { value: 'shipping', label: 'Shipping' },
  { value: 'both', label: 'Both' }
];
